import React from "react";
import {SV_API_BASE_URL} from '../config/api_endpoint'

export default function CustomerDetails() {
    const custNumber = new URLSearchParams(window.location.search).get('customerNumber');

    return <CustomerDetailsComponent custNumber={parseInt(custNumber)} />
}

export class CustomerDetailsComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      customer: null,
      error: null
    };
  }

  async componentDidMount() {
    const custNumber = this.props.custNumber;
    try {
      const response = await fetch(SV_API_BASE_URL +'GetKycByCustomerNumber?CustomerNumber=' + custNumber);
      const customerDetails = await response.json();
      if(customerDetails.length==0)
      {
        this.setState({ customer: "Customer Not Found" });
      }
      else
      {
        this.setState({ customer: customerDetails[0] });
      }
    } catch (error) {
      this.setState({ error: error.message });
    }
  }

  render() {
    const { customer, error } = this.state;

    if (error) {
      return <div>{error}</div>;
    }

    if (!customer) {
      return <div>Loading...</div>;
    }

    if(customer=="Customer Not Found")
    {
      return <div>{customer}</div>;
    }

    const { CustomerNumber, DocumentType, DocumentNumber, img } = customer;

    return (
      <div>
        <table>
            <tr>
                <td style={{fontSize:14, fontWeight:'bold' }}>Customer Number</td>
                <td>:</td>
                <td>{CustomerNumber}</td>
            </tr>
            <tr>
                <td style={{fontSize:14, fontWeight:'bold' }}>Document Type</td>
                <td>:</td>
                <td>{DocumentType}</td>
            </tr>
            <tr>
                <td style={{fontSize:14, fontWeight:'bold' }}>Document Number</td>
                <td>:</td>
                <td>{DocumentNumber}</td>
            </tr>
        </table>
        <table align="Center">
            <tr>
                <td colSpan="2">
                    <img src={img} alt={CustomerNumber} />
                </td>
            </tr>
        </table>
      </div>
    );
  }
}

